/**
 * Application configuration
 * Loads environment-specific settings from config files
 */

// Determine environment from build or default to dev
const environment = process.env.REACT_APP_ENV || 'dev';

// Import config based on environment
let config = {};

try {
  // In production build, config will be injected
  // For development, we'll use the dev config
  config = require(`../../../config/${environment}.json`);
} catch (error) {
  console.warn(`Could not load config for environment: ${environment}`, error);
  // Fallback to dev config
  config = {
    environment: 'dev',
    domain: 'devrmt.headforthe.cloud',
    api_domain: 'api.devrmt.headforthe.cloud',
    aws_region: 'eu-west-2'
  };
}

/**
 * Get the API base URL
 * @returns {string} API base URL
 */
export const getApiBaseUrl = () => {
  return `https://${config.api_domain}`;
};

/**
 * Get the WebSocket URL
 * @returns {string} WebSocket URL
 */
export const getWebSocketUrl = () => {
  return `wss://ws.${config.api_domain}/v1`;
};

/**
 * Get the application domain
 * @returns {string} Application domain
 */
export const getAppDomain = () => {
  return config.domain;
};

/**
 * Get the current environment
 * @returns {string} Environment name (dev, staging, prod)
 */
export const getEnvironment = () => {
  return config.environment;
};

/**
 * Get the AWS region
 * @returns {string} AWS region
 */
export const getAwsRegion = () => {
  return config.aws_region;
};

/**
 * Get OAuth configuration
 * @returns {Object} OAuth config
 */
export const getOAuthConfig = () => {
  return {
    google: {
      clientId: config.google_oauth_client_id
    },
    facebook: {
      appId: config.facebook_app_id
    }
  };
};

/**
 * Get Cognito configuration
 * @returns {Object} Cognito config
 */
export const getCognitoConfig = () => {
  return {
    userPoolId: config.cognito_user_pool_id,
    userPoolClientId: config.cognito_user_pool_client_id,
    domain: config.cognito_domain
  };
};

/**
 * Check if running in production
 * @returns {boolean} True if production environment
 */
export const isProduction = () => {
  return config.environment === 'prod';
};

/**
 * Check if running in development
 * @returns {boolean} True if development environment
 */
export const isDevelopment = () => {
  return config.environment === 'dev';
};

export default {
  ...config,
  getApiBaseUrl,
  getWebSocketUrl,
  getAppDomain,
  getEnvironment,
  getAwsRegion,
  getOAuthConfig,
  getCognitoConfig,
  isProduction,
  isDevelopment
};
